<template>
  <div>
    <div :id="props.id" :class="props.className" />
  </div>
</template>

<script setup>
import * as echarts from 'echarts/core'
import { GridComponent, TooltipComponent, VisualMapComponent } from 'echarts/components'
import { LineChart } from 'echarts/charts'
import { UniversalTransition } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'
import dayjs from 'dayjs'

const props = defineProps({
  data: {
    type: Array,
    default: () => []
  },
  direction: {
    type: Number,
    default: 0
  },
  xKey: {
    type: [String, Number],
    default: 'calculateTime'
  },
  yKey: {
    type: [String, Number],
    default: 'marketIndex'
  },
  id: {
    type: String,
    default: 'echart-dom'
  },
  className: {
    type: String,
    default: ''
  },
  lastDayEnd: {
    type: Boolean,
    default: false
  },
  showdetailtxt: {
    type: Boolean,
    default: false
  }
})

let data = ref(JSON.parse(JSON.stringify(props.data)))

data.value.array = []
data.value.yesterdayarray = []
let redStart = 0
let redstartTS = 0
let yesterdayLastData = ref(0)
onMounted(() => {
  var today = new Date()

  // 设置时间为00:00:00
  today.setHours(0, 0, 0, 0) //今天的 0点0分0秒

  // 获取时间戳（毫秒）
  var todaytimestamp = today.getTime()
  let maxTS = 0

  if (props.lastDayEnd) {
    for (let i = 0; i < data.value.length; i++) {
      const dataTS = dayjs(data.value[i][props.xKey] * 1000).valueOf()
      if (dataTS < todaytimestamp) {
        if (dataTS > maxTS) {
          maxTS = dataTS

          yesterdayLastData.value = data.value[i][props.yKey] //  昨天最后的数据
        }
      }
    }
  }

  for (let i = 0; i < data.value.length; i++) {
    if (yesterdayLastData.value) {
      data.value[i][props.yKey] = data.value[i][props.yKey] - yesterdayLastData.value // 今天的数据减去昨天最后那个数据的差值
    }
    // else {
    //   data.value[i][props.yKey] = data.value[i][props.yKey] - data.value[0][props.yKey] // 如果没有昨天的数据，今天的数据减去第一个数据的差值
    // }
    if (dayjs(data.value[i][props.xKey] * 1000).valueOf() > todaytimestamp && !redStart) {
      redStart = i
      redstartTS = data.value[i][props.xKey]
    }
    if (!redStart) {
      data.value.yesterdayarray.push([data.value[i][props.xKey] * 1, data.value[i][props.yKey]]) // 昨天的数据
    } else {
      data.value.array.push([data.value[i][props.xKey] * 1, data.value[i][props.yKey]]) //今天的
    }
  }
  echartInit()
})
function echartInit() {
  echarts.use([GridComponent, VisualMapComponent, LineChart, CanvasRenderer, UniversalTransition, TooltipComponent])

  var chartDom = document.getElementById(props.id)
  var myChart
  if (chartDom) {
    myChart = echarts.init(chartDom)
    var option
    var color = props.direction > 0 ? '255, 50, 51' : '61, 202, 100'
    data.value.array.unshift(data.value.yesterdayarray[data.value.yesterdayarray.length - 1])

    option = {
      grid: {
        y: 'datamin',
        height: '98%',
        left: 0,
        right: '2px',
        containLabel: false
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        show: false
      },
      tooltip: {
        appendToBody: true,
        trigger: 'axis',
        formatter: function (params) {
          var res = ''
          const value = params[0].value[1] + yesterdayLastData.value
          res =
            '<span style="color: #F87600;font-size: 16px">' +
            value.toFixed(2) +
            '</span>' +
            '<br/>' +
            '<span style="color: #979CAE">' +
            dayjs(params[0].value[0] * 1000).format('YYYY-MM-DD HH:mm') +
            '</span>' +
            '<br/>' 
            if( props.showdetailtxt){
              res += `<div class='mt-2' style="color: #979CAE"><span class='iconfont icon-xiangyou1' style='margin-right: 2px;font-size: 14px;'></span>点击查看详情</div>`
            }
          

          return res
        },
        textStyle: {
          // fontWeight: 'bold'
        }
      },
      yAxis: {
        type: 'value',

        show: false,
        // max: "dataMax",
        scale: true,
        axisLine: {
          // onZero: false
        }
      },
      visualMap: [
        {
          type: 'piecewise',
          show: false,
          dimension: 1,
          seriesIndex: 1,
          pieces: [
            {
              min: 0.0000001,
              color: 'red'
            },
            {
              max: 0,
              color: 'green'
            }
          ]
        }
      ],
      series: [
        {
          type: 'line',
          smooth: 0,
          symbol: 'none',
          lineStyle: {
            color: 'gray',
            width: 1
          },

          data: data.value.yesterdayarray
        },
        {
          type: 'line',
          smooth: 0,
          symbol: 'none',
          lineStyle: {
            width: 1
          },

          areaStyle: {
            opacity: 0.2
          },
          data: data.value.array
        }
      ]
    }
    option && myChart.setOption(option)
  }
}
</script>

<style lang="scss" scoped>
#echart-dom {
  width: 150px;
  height: 100px;
  // scale: 0.5;
  position: relative;
  // top: -30px;
  // left: -20px;
}
.trend-chart {
  width: 70px;
  height: 55px;
  // scale: 0.5;
  position: relative;
  // left: -15px;
  // top: -10px;
}
.market-trend-chart {
  width: 70px;
  height: 55px;
  // scale: 0.5;
  position: relative;
  // left: -25px;
}
.category-chart {
  width: 70px;
  height: 35px;
  // scale: 0.5;
  position: relative;
}
.detail-chart {
  width: 60px;
  height: 30px;
  // top: -20px;
  position: relative;
}
.newindex-chart {
  width: 180px;
  height: 70px;
}
.online-chart {
  width: 200px;
  height: 70px;
}
.section-chart {
  width: 100px;
  height: 80px;
}
</style>
